import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../Auth';
import { Card, Button, Modal, Accordion } from 'react-bootstrap';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';
import EditMaintenance from './EditMaintenance/EditMaintenance';
import Field from '../../Shared/Wizard/Field/Field';
import { Grid, Switch } from '@material-ui/core';
import StringToIcon from '../StringToIcon/StringToIcon';
import './MaintenanceResourceModal.scss'
import DateFormatter from '../DateFormatter/DateFormatter';
import { listeners } from 'process';
import BookingBilling from '../../Pages/BookingSingle/BookingBilling/BookingBilling';

function MaintenanceResourceModal(props) {
    // Props
    const showModal = props.showModal;
    const closeModal = props.closeModal;
    const resourceID = props.resourceID;

    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const t = useTranslate();

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });

    // States
    const [resource, setResource] = useState<Array<any>>([]);
    const [newMaintenanceModal, setNewMaintenanceModal] = useState(false);

    // New Maintenance
    const [newMaintenanceName, setNewMaintenanceName] = useState("");
    const [newMaintenanceType, setNewMaintenanceType] = useState({});
    const [newMaintenanceDescription, setNewMaintenanceDescription] = useState("");
    const [newMaintenancePriority, setNewMaintenancePriority] = useState("");
    const [showFinished, setShowFinished] = useState(false);
    const [maintenanceTypes, setMaintenanceTypes] = useState<Array<any>>([]);

    // Edit Maintenance
    const [currentEdit, setCurrentEdit] = useState(0);
    const [showEditModal, setShowEditModal] = useState(false);

    //multi resources
    const [multiResources, setMultiResources] = useState<Array<any>>([]);
    //const [resourceID, setResourceID] = useState("");

    const [toggleShowMoreText, setToggleShowMoreText] = useState("");

    function fetchData() {
        axios.all([
            axios.single({
                method: "get",
                url: "/api/resources/" + resourceID,
                responseType: "json",
                headers: { 'x-access-token': auth.user["token"] }
            }),
            axios.single({
                method: "get",
                url: "/api/maintenancetypes/",
                responseType: "json",
                headers: { 'x-access-token': auth.user["token"] }
            })
        ])
            .then(res => {
                setResource(res[0].data);
                setMaintenanceTypes(res[1].data);


            }).catch(err => console.log(err));
    }

    function handleCreateMaintenance() {
        if (newMaintenanceName == "") { notifyWarning(t("maintenance.toast_maintenance_empty_name")); return undefined; }
        if (!newMaintenanceType || newMaintenanceType == "" || newMaintenanceType == undefined) { notifyWarning(t("maintenance.toast_maintenance_empty_type")); return undefined; }
        if (!newMaintenancePriority || newMaintenancePriority == "" || newMaintenancePriority == undefined) { notifyWarning(t("maintenance.toast_maintenance_empty_priority")); return undefined; }

        if(props.multiResources == undefined ||  props.multiResources.length == 0 ){
            const tempDate = new Date();
            let tempMaintenance = {
                "name": newMaintenanceName,
                "type": maintenanceTypes != undefined ? maintenanceTypes.find((i) => i["_id"] == newMaintenanceType) : "",
                "description": newMaintenanceDescription,
                "priority": newMaintenancePriority,
                "started": tempDate,
                "madeBy": auth.user["userdata"]["name"],
                "done": false,
            }

            axios.put(
                "/api/resources/maintenance/" + resource["_id"],
                {
                    maintenance: tempMaintenance
                },
                {
                    headers: { 'x-access-token': auth.user["token"] }
                }
            ).then(() => {
                fetchData();
                handleCloseNew();
                cleanNewForm();
            })
        } else if(props.multiResources.length != 0) {
                const tempDate = new Date();
                let tempMaintenance  = {
                    "name": newMaintenanceName,
                    "type": maintenanceTypes.find((i) => i["_id"] == newMaintenanceType),
                    "description": newMaintenanceDescription,
                    "priority": newMaintenancePriority,
                    "started": tempDate,
                    "madeBy": auth.user["userdata"]["name"],
                    "done": false,
                }

            axios.put(
                "/api/resources/maintenance/updatemany" ,
                {
                    maintenance: tempMaintenance,
                    multiResources: multiResources
                },
                {
                    headers: { 'x-access-token': auth.user["token"] }
                }
            ).then(() => {
                handleCloseNew();
                cleanNewForm();
                if (props.closeModal != undefined) {
                    props.closeModal();
                }
            })
        }
    }

    function cleanNewForm() {
        setNewMaintenanceName("");
        setNewMaintenanceType({});
        setNewMaintenancePriority("");
        setNewMaintenanceDescription("");
    }

    function handeShowNew() {
        setNewMaintenanceModal(true);
    }
    function handleCloseNew() {
        setNewMaintenanceModal(false);
        cleanNewForm();
    }

    function handleShowEditModal(evt, key) {
        evt.preventDefault();
        evt.stopPropagation();
        setCurrentEdit(key);
        setShowEditModal(true);
    }

    function handleShowText(key, lineNumber) {
        if(toggleShowMoreText == "open-" + lineNumber + key){
            setToggleShowMoreText("");
        }else{
            setToggleShowMoreText("open-" + lineNumber + key);
        }
       
    }

    function handleShowSelectedResources() {
        const result = props.allResources.filter(i => {
            let arr = props.multiResources.filter(m => m._id === i._id)
            return !(arr.length === 0)
        });  

        setMultiResources(result);
    }

    useEffect(() => {
        if (showModal) {
            if(props.multiResources != undefined && props.multiResources.length != 0) {
                handleShowSelectedResources();
                fetchData();
            } else if(props.resourceID != "" ) {
                fetchData();
            }
        }
    }, [showModal]);

    return (
        <>
            <Modal className="maintenancemodal" show={showModal} onHide={() => closeModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {
                            props.resourceID != "" ? t("maintenance.info_modal") + " " + ((props.allResources.find(i => i._id == props.resourceID)|| { name: "" })["name"]) 
                            :
                            t("maintenance.info_modal") + " " + multiResources.map(item=> item.name).join(", ")
                        }
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Button onClick={handeShowNew} disabled={!(maintenanceTypes.length > 0)}>{t("maintenance.new")}</Button>
                    { !(maintenanceTypes.length > 0) ?
                        <p>{t("maintenance.no_maintenancetypes_found")}</p>
                    : 
                        props.showToggle ?  
                        <Grid component="label" container alignItems="center" spacing={1}>
                            <Grid item>
                                <Switch
                                    size="small"
                                    checked={showFinished}
                                    onChange={(evt) => setShowFinished(evt.currentTarget.checked)}
                                    className={"toggleSwitch"}
                                    color="primary"
                                />
                            </Grid>
                            <Grid item>{t("maintenance.show_finished")}</Grid>
                        </Grid> 
                        :
                        null
                    }
                        { props.multiResources == undefined || props.multiResources.length == 0 ?  /* when if multiResources exist, then show no existing maintenance tasks, to prevent when if user select "all rooms" */
                            <div className="cardsContainer">
                                { resource["maintenance"] != undefined ? resource["maintenance"].map((i, key) => {
                                    if (showFinished === false && i["done"] == true) {
                                        return null;
                                    }

                                    return <Card key={key} className="" onClick={() => handleShowText(key, 1)}>
                                                {i["done"] == true ? <i className="checkIcon dripicons-checkmark" /> : null}
                                                <div className="maintenanceCard" style={{height: "auto"}}>
                                                    <div className="mt-2 iconDiv">
                                                        <StringToIcon icon={i["type"]} />
                                                    </div>
                                                    <div className={"maintenanceResourceTextDiv" + (toggleShowMoreText == "open-1" + key ? " openBox" : "" )}>
                                                        <div className={"mt-1" }  style={{fontSize: "20px"}}>
                                                            <p >{i["name"]}</p>
                                                        </div>
                                                        <div className={"mt-1"} style={{fontSize: "15px", minHeight: "21px"}}>
                                                            <p>{i["description"]}</p>
                                                        </div>
                                                        <div className="mb-1 mt-1 dateLine" style={{fontSize: "10px"}}>
                                                            <div>
                                                                <p>{"Laget: "}<DateFormatter date={i["started"]} /> {" av " + i["madeBy"]}</p>
                                                                {i["done"] && <p>{"Ferdig: "}<DateFormatter date={i["finished"]} /> {" av " + i["finishedBy"]}</p>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="mt-2 editAndChevronDiv">
                                                        <Button onClick={(evt) => handleShowEditModal(evt, key)}><i className="dripicons-gear"/></Button>
                                                        <i className={"chevron" + (toggleShowMoreText == "open-1" + key ? " dripicons-chevron-down" : " dripicons-chevron-left")} />
                                                    </div>
                                                </div>
                                            </Card>
                                }) : null} 
                            </div>
                        : null
                    }
                </Modal.Body>
            </Modal>

            {/* New maintenance modal*/}
            <Modal show={newMaintenanceModal} onHide={handleCloseNew}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("maintenance.new_title")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Field
                        type="input"
                        title={t("maintenance.new_name")}
                        value={newMaintenanceName}
                        onChange={value => setNewMaintenanceName(value)}
                        placeholder={t("maintenance.new_name")}
                    />
                    <Field
                        type="select"
                        title={t("maintenance.new_type")}
                        value={{ value: newMaintenanceType }}
                        onChange={value => { setNewMaintenanceType(value.value); }}
                        options={{
                            choosetext: t("maintenance.choosetext_type"),
                            choices: maintenanceTypes != undefined ? (maintenanceTypes.map(i => { return { label: i["name"], value: i["_id"] } })) : null
                        }}
                    />
                    <Field
                        type="select"
                        title={t("maintenance.new_priority")}
                        value={{ value: newMaintenancePriority }}
                        onChange={value => setNewMaintenancePriority(value.value)}
                        options={{
                            choosetext: t("maintenance.choosetext_priority"),
                            choices: [
                                { label: t("maintenance.priority_low"), value: "low" },
                                { label: t("maintenance.priority_medium"), value: "medium" },
                                { label: t("maintenance.priority_high"), value: "high" },
                            ]
                        }}
                    />
                    <Field
                        type="textarea"
                        title={t("maintenance.new_description")}
                        value={newMaintenanceDescription}
                        onChange={value => setNewMaintenanceDescription(value)}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseNew}>
                        {t("maintenance.cancel")}
                    </Button>
                    <Button onClick={handleCreateMaintenance}>
                        {t("maintenance.save")}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Edit maintenance modal*/}
            <EditMaintenance
                showEditMaintenance={showEditModal}
                setShowEditMaintenance={setShowEditModal}
                resourceID={resourceID}
                maintenanceKey={currentEdit}
                runOnEdit={fetchData}
            />
        </>
    )
}

export default MaintenanceResourceModal;